var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "proposal-documents" },
    [
      _c(
        "validation-observer",
        { ref: "proposalDocuments" },
        [
          _c("amendment-document", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.visibleAmendment,
                expression: "visibleAmendment"
              }
            ],
            attrs: { "amendment-document": _vm.amendmentDocument },
            on: { "on-upload-file": _vm.uploadDocumentHandler }
          })
        ],
        1
      ),
      _c("section-title", {
        staticClass: "mt-4 mb-3",
        attrs: {
          "has-line": "",
          title: "Documentos Propuesta",
          "title-class": "section-title-info"
        }
      }),
      _vm._l(_vm.page.data, function(document, idx) {
        return _c(
          "div",
          { key: idx, staticClass: "proposal-documents__element" },
          [
            _c("document-info", {
              attrs: {
                "add-file": _vm.canEditDocuments,
                document: document,
                "file-preview": !_vm.canEditDocuments,
                "show-filename": ""
              },
              on: {
                "on-upload-file": function($event) {
                  return _vm.onUploadFile($event, document)
                }
              }
            })
          ],
          1
        )
      }),
      _vm.page.totalItemCount > _vm.pageSize
        ? _c("pagination", {
            attrs: { data: _vm.page, "page-size": _vm.pageSize },
            on: { "pagination-go-page": _vm.setCurrentPage }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }